
import { supabase } from '../../supabase';
import { AuthFilter } from '@/components/analytics/AuthFilterButtons';

export interface LanguageStat {
  language: string;
  count: number;
}

/**
 * Get language distribution statistics
 */
export const getLanguageStats = async (
  startDate: Date, 
  endDate: Date,
  authFilter: AuthFilter = 'all'
): Promise<LanguageStat[]> => {
  const { data, error } = await supabase.rpc('get_language_stats_aggregated', {
    start_date: startDate.toISOString(),
    end_date: endDate.toISOString(),
    auth_filter: authFilter
  });
  
  if (error) {
    console.error('Error fetching language stats:', error);
    throw error;
  }
  
  return (data || []).map(item => ({
    language: item.language,
    count: Number(item.count)
  }));
};
